"use strict";

const http = require("client/http_client");
const staticData = require("client/static_data");

/**
 * The factory is invoked TWICE — index.js calls it to register the download
 * listener, presentation.js calls it again for its sendTextEmail handle. Since
 * invoking it is what registers the document-level listener, the second call
 * used to register a duplicate: one DOWNLOAD_FILE event then ran two HEAD
 * requests (two GETs for a valid token, the second one rejected after the
 * single-use token was consumed). Register once, on the first invocation.
 */
let downloadListenerRegistered = false;

function _downloadFile (href) {
    const axiosConfig = {
        url: href,
        method: "head"
    };
    http(axiosConfig).then(function () {
        window.location.href = href;
    }).catch(function (error) {
        /**
         * A HEAD that fails without a response (network down, timeout,
         * aborted) has no x-message header: the native navigation was
         * already cancelled, so the banner must still be shown.
         */
        const payload = {
            error: error.response ?
                error.response.headers["x-message"] :
                staticData.errors.FILE_NOT_FOUND.message
        };
        document.dispatchEvent(new CustomEvent('DOWNLOAD_FILE_ERROR', { detail: payload }));
    })
}

module.exports = function dataAccess () {

    if (!downloadListenerRegistered) {
        downloadListenerRegistered = true;
        document.addEventListener('DOWNLOAD_FILE', (e) => {
            _downloadFile(e.detail.href);
        });
    }

    return {

        sendTextEmail: function (payload) {
            const url = "/api/email";
            return http.post(url, payload);
        }
    };
};
